import React, {useState} from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, DialogActions, TextField, Button} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';


const useStyles = makeStyles((theme) => ({
  
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    
  },
  
  dialogActions: {
    justifyContent: 'flex-start',
    padding: theme.spacing(3),
  },

  buttonGreen: {
    background: '#90C71A',
    color: '#fff',
  },
  
  textarea: {
    '& .MuiInputLabel-root.Mui-focused': {
      color: '#90C71A',
    },
    
    '& .Mui-focused.MuiInput-underline:after': {
      borderColor: '#90C71A',
    },
    
    '& .MuiInput-underline:not(".Mui-error"):after': {
      borderColor: '#90C71A',
    },
  },
}));


function CommentModal(props) {
  
  const classes = useStyles();

  const [comment, setComment] = useState('');
  const [error, setError] = useState('');

  const changeComment = (e) => {
    setComment(e.target.value);
    setError('');
  };
  
  const submitForm = () => {
    if (comment) {
      setError('');
      props.addComment(comment);
      props.handleClose();
    } else {
      setError('Поле комментария не может быть пустым');
    }
  };

  
  return (
    <Dialog open={props.openModal} onClose={props.handleClose} fullWidth >
      <DialogTitle id="form-dialog-title">Добавить комментарий
        <IconButton aria-label="Закрыть" className={classes.closeButton} onClick={props.handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          id="comment"
          multiline
          label="Ваш комментарий"
          type="text"
          fullWidth
          rows={3}
          rowsMax={6}
          className={classes.textarea}
          error={error ? true : false}
          helperText={error}
          onChange={(e) => changeComment(e)}
        />
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button onClick={() => submitForm()} className={classes.buttonGreen} variant="contained">
          ДОБАВИТЬ
        </Button>
      </DialogActions>
    </Dialog>
  );
}


export default CommentModal;
